import find from 'lodash/find';
import { computed, ref, unref } from 'vue';
const usersOnboardingFlow = ref([]);
const usersOnboardingSteps = ref([]);
const activeStepIndex = ref(0);
const hasOnboardingAccess = ref(null);

export default function useOnboarding () {
    const setActiveStepIndex = (stepIndex) => {
        activeStepIndex.value = stepIndex;
    };

    const setUsersOnboardingFlow = (onboardingFlow) => {
        usersOnboardingFlow.value = onboardingFlow;
    };

    const setUsersOnboardingSteps = (onboardingSteps) => {
        usersOnboardingSteps.value = onboardingSteps;
    };

    const activeStep = computed(() => unref(usersOnboardingSteps)[unref(activeStepIndex)]);

    const getStepByKey = (key) => find(unref(usersOnboardingSteps), (step) => step.key === key);

    const setStepCompleted = (stepKey) => {
        const step = getStepByKey(stepKey);
        step.isCompleted = true;
    };

    const isFirstStep = computed(() => unref(activeStepIndex) === 0);
    const isLastStep = computed(() => unref(activeStepIndex) === unref(usersOnboardingSteps).length - 1);

    const setHasOnboardingAccess = (access) => {
        hasOnboardingAccess.value = access;
    };

    return {
        usersOnboardingFlow,
        usersOnboardingSteps,
        activeStepIndex,
        activeStep,
        isFirstStep,
        isLastStep,
        hasOnboardingAccess,

        getStepByKey,
        setActiveStepIndex,
        setUsersOnboardingFlow,
        setUsersOnboardingSteps,
        setStepCompleted,
        setHasOnboardingAccess,
    };
}
